<template>
  <div class="wrapper">
    <a :href="url"
      v-gtm-tracker="gtmType"
      :title="title"
      :target="target"
      class="abacus-special"
      >{{ label }}</a>

    <a :href="url"
      v-gtm-tracker="gtmType"
      :title="title"
      :target="target"
      class="content"
      >
      <div class="content-title">{{ title }}</div>
      <onload-idle-queue>
        <img class="hidden-sm-up" :src="image" />
      </onload-idle-queue>
    </a>
  </div>
</template>
<script>
import chinaInterReportConfig from 'config/china-internet-report'
import get from 'lodash/get'
import find from 'lodash/find'

export default {
  name: 'china-internet-report-entry-slot',
  data() {
    const {
      WIDGET_FOOTER_TITLE: title = '',
      WIDGET_LABEL: label = '',
      WIDGET_PATH: url = '',
      WIDGET_IMAGE: image = '',
      NEW_WINDOW: new_window = '',
    } = find(get(chinaInterReportConfig, 'ROUTES', []), {ID: 'report'})
    return {
      title,
      label,
      url,
      image,
      target: new_window ? '_blank' : '_self',
    }
  },
  computed: {
    gtmType() {
      return {
        ec: 'China Internet Report',
        ea: 'China Internet Report/Entry Point/Click',
        el: get(this, '$route.path', ''),
      }
    },
  },
}
</script>
<style scoped lang="scss">
  .wrapper {
    font-family: $barlow;
    @include respond-to('desktop') {
      padding-left: rem-calc(16);
      padding-right: rem-calc(16);
    }
  }
  .abacus-special {
    display: block;
    text-transform: uppercase;
    padding-top: rem-calc(11);
    color: $turquoise;
    font-weight: bold;
    font-size: rem-calc(14);
    line-height: rem-calc(17);

    &:hover {
      text-decoration: none;
    }

    @include respond-to('desktop') {
      padding-top: rem-calc(15);
      margin-bottom: rem-calc(8);
      font-size: rem-calc(16);
      line-height: rem-calc(19);
    }
  }
  .content {
    display: flex;
    color: $white;
    margin-bottom: rem-calc(11);
    justify-content: space-between;
    img {
      width: rem-calc(80);
      min-width: rem-calc(80);
      height: rem-calc(80);
    }

    &-title {
      text-transform: capitalize;
      font-size: rem-calc(21);
      line-height: rem-calc(24);
      color: $white;
      padding-right: rem-calc(12);
      @include respond-to('desktop') {
        font-size: rem-calc(20);
        line-height: rem-calc(26);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// components/widgets/ChinaInternetReportEntrySlot.vue